const collaborationTour = {
  id: 'collaboration',
  title: 'Commenting',
  summary: 'Raise questions and work through them as a team.',
  // Only an open schedule sheet has these targets; the list page has none.
  match: '/dashboard/yawn/schedule/,!/dashboard/yawn/schedule/list,!/dashboard/yawn/schedule/new',
  autoStart: false,
  version: 1,
  steps: [
    {
      target: 'sheet-row-comment',
      title: 'Comment on any row',
      body: 'Open a row comment thread to raise a question against that specific item.',
      placement: 'right',
      optional: true,
    },
    {
      target: 'sheet-comment-mention',
      title: 'Ask someone directly',
      body: 'Type @ and pick a team member to direct the comment at them.',
      placement: 'top',
      optional: true,
    },
    {
      target: 'sheet-menu-comments',
      title: 'Every comment in one place',
      body: 'The "Comments" menu groups everything into Incoming, Outgoing and Resolved, with the code and item for each. Click one to jump to that row.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-active-users',
      title: 'Who else is here',
      body: 'See who is in the schedule with you right now.',
      placement: 'bottom',
      optional: true,
    },
  ],
};

export default collaborationTour;
